import * as React from "react";
import { RouteProps } from "react-router";

type TitleableRouteProps = RouteProps & {
    title: string;
    element: React.ReactElement;
}

export const TitleableRoute: React.FC<TitleableRouteProps> = ({ title, element }) => {
    React.useEffect(() => {
        document.title = title;
        // eslint-disable-next-line
    }, [title]);

    return element;
};